import { useToastContext } from "components/alert/ToastContext";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import { Label } from "components/input/Label";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Local from "model/patrimonio/Local";
import Patrimonio from "model/patrimonio/Patrimonio";
import ItemNotaFiscalEntrada from "model/suprimentos/ItemNotaFiscalEntrada";
import { Button } from "primereact/button";
import { Column, ColumnEditorOptions } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import NotaFiscalEntradaService from "service/suprimentos/NotaFiscalEntradaService";

type Props = {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    style?: React.CSSProperties | undefined;
    fornecedor: Pessoa;
    itemNota: ItemNotaFiscalEntrada;
    quantidade: number;
    onConfirm: (patrimonios: Patrimonio[]) => void;
    onCancel: () => void;
}

const notaFiscalEntradaService = new NotaFiscalEntradaService();

export default function PatrimonioPorNotaModal(props: Props) {

    const [patrimonio, setPatrimonio] = useState<Patrimonio>(new Patrimonio());
    const [patrimonios, setPatrimonios] = useState<Patrimonio[]>([]);
    const [codigo, setCodigo] = useState<number>(0)
    const { msgAlerta } = useToastContext();

    useEffect(() => {
        notaFiscalEntradaService.proximoCodigo().then((data) => {
            setCodigo(Number(data));
        }).catch((error) => {
            console.log(error);
        })
    })

    useEffect(() => {
        if (props.visible) {
            console.log()
            const patrimoniosLista = [];
            for(let i = 0; i < props.quantidade; i++) {
                console.log("Numero ae" + i);
                const patrimonioLocal = new Patrimonio();
                patrimonioLocal.local = props.itemNota.local;
                patrimonioLocal.fornecedor = props.fornecedor;
                patrimonioLocal.codigo = (codigo + i).toString();
                patrimoniosLista.push(patrimonioLocal);
            }
            setPatrimonios(patrimoniosLista)
        }
    }, [props.visible, props.itemNota]);

    useEffect(() => {
        if (!props.visible) {
            setPatrimonio(new Patrimonio());
            setPatrimonios([]);
        }
    }, [props.visible, props.itemNota]);

    const validar = (): boolean => {
       const invalido = patrimonios.some((patrimonio) => {
            if (!patrimonio.codigo) {
                msgAlerta("Alerta", "Codigo Invalido");
                return true;
            }
            return false;
        })

        return !invalido;
    }

    const fechar = () => {
        props.setVisible(false);
        props.onCancel();
    }

    const isKgouLt = (unidadeMedida: string) => {
        return unidadeMedida == "KG" || unidadeMedida == "LT";
    }

    const confirmar = () => {
        if(validar()) {
            setCodigo(codigo + props.quantidade)
            props.onConfirm(patrimonios);
        }
        console.log(patrimonios);
    }

    const editorCodigo = (options: ColumnEditorOptions) => {
        return <InputText
        required value={options.rowData["codigo"]}
        style={{ width: '100%' }}
        onChange={(e) => {
            options.rowData.codigo = e.target.value;
            const patrimoniosLocal = [...patrimonios];
            patrimoniosLocal[options.rowIndex].codigo = options.rowData["codigo"];
            setPatrimonios(patrimoniosLocal);
        }}
    />
    }

    const editorNumeroSerie = (options: ColumnEditorOptions) => {
        return <InputText
        required value={options.rowData["numeroSerie"]}
        style={{ width: '100%' }}
        onChange={(e) => {
            options.rowData.numeroSerie = e.target.value;
            const patrimoniosLocal = [...patrimonios];
            patrimoniosLocal[options.rowIndex].numeroSerie = options.rowData["numeroSerie"];
            setPatrimonios(patrimoniosLocal);
        }}
    />
    }

    const editorModelo = (options: ColumnEditorOptions) => {
        return <InputText
        required value={options.rowData["modelo"]}
        style={{ width: '100%' }}
        onChange={(e) => {
            options.rowData.modelo = e.target.value;
            const patrimoniosLocal = [...patrimonios];
            patrimoniosLocal[options.rowIndex].modelo = options.rowData["modelo"];
            setPatrimonios(patrimoniosLocal);
        }}
    />
    }

    return (
        <Dialog header="Cadastro de Patrimônio" visible={props.visible} style={{ width: '50vw', ...props.style }} onHide={() => { fechar() }}
            footer={<>
                <Button label="Cancelar" onClick={() => fechar()} />
                <Button label="Confirmar" onClick={() => {
                    console.log(codigo)
                    confirmar()
                }} />
            </>}>
            <div className="row">
                <label className="col col-sm-12">
                    Produto: {props.itemNota.produto?.nome}
                </label>
                <label className="col col-sm-12">
                    Local: {props.itemNota.local?.nome}
                </label>
            </div>

            <BaseDataTableEdit
                tituloLista="Patrimonios"
                getNewModel={() => new Patrimonio()}
                lista={patrimonios ? patrimonios : []}
                setLista={(e) => setPatrimonios(e as Patrimonio[])}
                dataKey="key"
                showDelete={false}
                addButtonDisabled={true}
            >
                <Column field="codigo" header="Código" editor={(options) => editorCodigo(options)} />
                <Column field="numeroSerie" header="Número de Série" editor={(options) => editorNumeroSerie(options)}/>
                <Column field="modelo" header="Modelo" editor={(options) => editorModelo(options)} />
            </BaseDataTableEdit>
        </Dialog>
    )
}